import React from "react";
import { PhoneIcon } from "lucide-react";
import { firm, footerGroups, resultsDisclaimer } from "../data/site";
import { SiteLink } from "./SiteLink";
export function SiteFooter() {
  return <footer className="on-dark bg-ink text-white" data-id="element-204" data-mp="3mh1206y44y0m">
      <div className="page-container py-14 md:py-16" data-id="element-205" data-mp="3mfpxg4wufm8g">
        <div className="grid gap-10 md:grid-cols-12" data-id="element-206" data-mp="3hj7xrjgdee2z">
          <div className="md:col-span-6" data-id="element-207" data-mp="3hglsjqgycanx">
            <p className="text-h3 font-bold" data-id="element-208" data-mp="3dh4kcpa54zf2">{firm.legalName}</p>
            <p className="mt-1 text-white/80" data-id="element-209" data-mp="38hrnrctgwdza">
              {firm.attorney}, {firm.mark}
            </p>
            <a href={firm.phoneHref} className="mt-5 inline-flex min-h-[48px] items-center gap-3 text-h3 font-extrabold text-white hover:underline" data-id="element-210" data-mp="33iovksyl628q">
              <PhoneIcon aria-hidden="true" className="h-6 w-6" data-id="element-211" data-mp="2ylyb7tfr0khi" />
              {firm.phoneDisplay}
            </a>
          </div>
          {footerGroups.map(group => <nav key={group.id} aria-labelledby={group.id} className="md:col-span-3" data-id="element-212" data-mp="wt0f9oqodbsc">
              <h2 id={group.id} className="text-label font-bold text-white/80" data-id="element-213" data-mp="15pae1bexd2hv">
                {group.label}
              </h2>
              <ul className="mt-3" data-id="element-214" data-mp="1anlnvm57zd03">
                {group.links.map(link => <li key={link.path} data-id="element-215" data-mp="vuifo5diqbm1">
                    <SiteLink path={link.path} className="inline-flex min-h-[44px] items-center text-label font-semibold text-white underline-offset-4 hover:underline" data-id="element-216" data-mp="10rikye2jnac3">
                      {link.label}
                    </SiteLink>
                  </li>)}
              </ul>
            </nav>)}
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/20 pt-6 text-meta text-white/80 md:flex-row md:justify-between" data-id="element-217" data-mp="1jqczbly3i8rq">
          <p data-id="element-218" data-mp="27ffjb0g7cdpe">{resultsDisclaimer}</p>
          <p data-id="element-219" data-mp="27ee3yjs5l51v">© 2026 {firm.legalName}</p>
        </div>
      </div>
    </footer>;
}